import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService, CommonService } from '@app/_services';
import { environment } from '@environments/environment';
@Component({
  selector: 'app-new-homepage-header',
  templateUrl: './new-homepage-header.component.html',
  styleUrls: ['./new-homepage-header.component.less']
})
export class NewHomepageHeaderComponent implements OnInit {
  userName = "";
  menuList: any[];
  localLogin: string = environment.apiUrl + "authentication/localui/login?username=chinival";
  loginUrl: string;
  userData: any;
  authSubject: any;
  isAuthenticated: boolean = false;
  constructor(private router: Router, private auth: AuthenticationService,private common: CommonService,private postLogin:AuthenticationService) {}

  ngOnInit() {
    this.userData = this.auth.currentUserValue;
    if(this.userData !== null) {
      this.userName= this.userData.userMetadata.firstName;
    }
    this.auth.isAuthSubject.subscribe((auth) => (this.isAuthenticated = auth));
    // this.loginUrl = environment.loginUrl;
  }

  login(){
    if(environment['environment'] === 'local'){
      this.userData = this.auth.loginWithoutOkta().subscribe(res=>{
        this.userData = res.response
        if(this.userData !== null) {
          this.userName= this.userData.userMetadata.firstName;
        }
        this.auth.postLogin(res.response,'http://localhost:4200/#relay/home')
      })
    }else{
      window.location.href = environment.loginUrl
    }
  }

  isRouteActive(pathArray: any[]): boolean {
    let highlight: boolean = false;
    if (pathArray && pathArray.length != 0) {
      pathArray.forEach((path) => {
        if (this.router.isActive(path, false) == true) {
          highlight = true;
          return true;
        }
      });
    }
    return highlight;
  }

  logout() {
    this.auth.logout();
  }

}
